enum Extensions {
	PROJECT_EXTENSION = 'eproj',
	FORM_EXTENSION = 'efrm',
	APP_FORM_EXTENSION = 'eaf',
	FLOW_EXTENSION = 'eflw',
	FOLDER_EXTENSION_1 = '',
	FOLDER_EXTENSION_2 = 'folder'
}
export { Extensions };
